<template>
    <div>
        <v-form ref="formulario">
            <v-container fluid>
                <v-row>
                    <v-col>
                        <h2 v-text="'Buscador Avanzado'"></h2>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col></v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field clearable v-model="model.cod_formula" label="Codigo" required />
                    </v-col>
                    <v-col>
                        <v-text-field clearable v-model="model.descripcion" label="Descripción" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field clearable v-model="model.cliente" label="Cliente" />
                    </v-col>
                    <v-col>
                        <v-text-field clearable v-model="model.especificacion" label="Especificación" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col lg="6" md="6" sm="6">
                        <v-autocomplete clearable v-model="model.colores" :items="colores" label="Color"
                            prepend-icon="mdi-palette" :item-text="getColorName" item-value="id_color" multiple
                            return-object chips>

                            <template v-slot:selection="data">
                                <v-chip v-bind="data.attrs" :input-value="data.item.id_color" close @click="data.select"
                                    @click:close="removeColor(data.item)">
                                    {{ getColorName(data.item) }}
                                </v-chip>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col>
                        <v-autocomplete clearable v-model="model.proceso" :items="proceso" item-text="name"
                            item-value="value" label="Proceso" :filter="customFilter">
                        </v-autocomplete>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="2">
                        <v-select v-model="model.temp_comparacion" :items="comparacion" item-text="name" item-value="value"
                            prepend-icon="mdi-thermometer" />
                    </v-col>
                    <v-col>
                        <v-text-field clearable label="Temperatura Servicio" type="number" suffix="ºC"
                            v-model="model.temp_servicio" />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-text-field clearable label="Densidad Mínima" type="number" v-model="model.mindensidad"
                            prepend-icon="mdi-dots-hexagon" />
                    </v-col>
                    <v-col>
                        <v-text-field clearable label="Densidad Máxima" type="number" v-model="model.maxdensidad"
                            prepend-icon="mdi-dots-hexagon" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-autocomplete clearable v-model="model.aplicaciones" :items="aplicaciones" label="Aplicaciones"
                            prepend-icon="mdi-application" item-text="nombre" item-value="id_aplicacion" multiple
                            return-object chips>

                            <template v-slot:selection="data">
                                <v-chip v-bind="data.attrs" :input-value="data.item.id_aplicacion" close
                                    @click="data.select" @click:close="removeAplicacion(data.item)">
                                    {{ data.item.nombre }}
                                </v-chip>
                            </template>

                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-autocomplete clearable v-model="model.bases" :items="bases" label="Bases"
                            :item-text="getBaseName" item-value="cod_base" multiple return-object chips>

                            <template v-slot:selection="data">
                                <v-chip v-bind="data.attrs" :input-value="data.item.cod_base" close @click="data.select"
                                    @click:close="removeBase(data.item)">
                                    {{ data.item.cod_base }}
                                </v-chip>
                            </template>

                        </v-autocomplete>
                    </v-col>
                    <v-col>
                        <v-autocomplete clearable v-model="model.aditivos" :items="aditivos" label="Aditivos"
                            :item-text="getAditivoName" item-value="cod_aditivo" multiple return-object chips>

                            <template v-slot:selection="data">
                                <v-chip v-bind="data.attrs" :input-value="data.item.cod_aditivo" close @click="data.select"
                                    @click:close="removeAditivo(data.item)">
                                    {{ data.item.cod_aditivo }}
                                </v-chip>
                            </template>

                        </v-autocomplete>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-row>
                            <v-col>
                                <v-radio-group v-model="model.platino" row>
                                    <v-radio :value=true label="Platino"></v-radio>
                                    <v-radio :value=false label="Peroxido"></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col>
                                <v-checkbox indeterminate v-model="model.aceite" label="Aceite" />
                            </v-col>
                            <v-col>
                                <v-checkbox indeterminate v-model="model.cables" label="Cables" />
                            </v-col>
                            <v-col>
                                <v-checkbox indeterminate v-model="model.esponja" label="Esponja" />
                            </v-col>
                            <v-col>
                                <v-checkbox indeterminate v-model="model.desmoldeo" label="Desmoldeo" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-checkbox indeterminate v-model="model.fda" label="FDA" />
                            </v-col>
                            <v-col>
                                <v-checkbox indeterminate v-model="model.fuego" label="Fuego" />
                            </v-col>
                            <v-col>
                                <v-checkbox indeterminate v-model="model.grasa" label="Grasa" />
                            </v-col>
                            <v-col>
                                <v-checkbox indeterminate v-model="model.green_strength" label="Green Strength" />
                            </v-col>
                            <v-col></v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-row>
                            <v-col>
                                <Postcurado :key="sinpostKey" :search="true" title="Sin Postcurado" icon="mdi-chart-donut"
                                    :formula="model.sinpostcurado" />
                            </v-col>
                            <v-col>
                                <Postcurado :key="conpostKey" :search="true" title="Con Postcurado"
                                    icon="mdi-chart-donut-variant" :formula="model.postcurado" />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row align="center">
                    <v-col align="center">
                        <v-btn color="primary" x-large @click="advancedSearch" :loading="searching" :disabled="searching"
                            class="ma-2">
                            <v-icon left>mdi-magnify</v-icon>
                            Buscar
                            <template v-slot:loader>
                                <span>Procesando</span>
                            </template>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>

        <v-container fluid>
            <v-row>
                <v-col v-if="res_formulas">
                    <ListaSugerencias :key="listaKey" :busqueda="res_formulas" title="Resultado Búsqueda" />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapMutations } from "vuex";
import AditivosDataService from "@/services/AditivosDataService";
import AplicacionesDataService from "@/services/AplicacionesDataService";
import BasesDataService from "@/services/BasesDataService";
import ColoresDataService from "@/services/ColoresDataService";
import FormulasDataService from "@/services/FormulasDataService";
import Postcurado from "@/components/Postcurado.vue";
import ListaSugerencias from "@/components/ListadoFormulas.vue";


export default {
    name: "FormulasSearch",
    data: () => ({
        res_formulas: null,
        search: '',
        sortBy: 'cod_formula',
        sortDesc: false,
        list_header: [
            { text: 'CODIGO', value: 'cod_formula' },
            { text: 'DESCRIPCIÓN', value: 'descripcion' },
            { text: 'TEMP.SERVICIO', value: 'temp_servicio' },
            { text: 'FDA', value: 'fda' },
        ],
        searching: false,
        aditivos: [],
        aplicaciones: [],
        bases: [],
        colores: [],
        proceso: [
            { name: "Autoclave", abbr: "AC", value: "autoclave" },
            { name: "Calandra", abbr: "C", value: "calandra" },
            { name: "Extrusion", abbr: "E", value: "extrusion" },
            { name: "Moldeo", abbr: "M", value: "moldeo" },
        ],
        comparacion: [
            { name: ">", value: "gt" },
            { name: ">=", value: "gte" },
            { name: "==", value: "e" },
            { name: "<", value: "lt" },
            { name: "<=", value: "lte" },
        ],
        sinpostKey: 0,
        conpostKey: 0,
        model: {
            temp_comparacion: 'e',
            postcurado: {
                alargamiento_comparacion: 'e',
                carga_rot_mpa_comparacion: 'e',
                desgarro_comparacion: 'e',
                c_set_comparacion: 'e',
                valor: '-',
                alargamiento: null,
                c_set: null,
                carga_rot_mpa: null,
                desgarro: null,
                mindureza: null,
                maxdureza: null,
            },
            sinpostcurado: {
                alargamiento_comparacion: 'e',
                carga_rot_mpa_comparacion: 'e',
                desgarro_comparacion: 'e',
                c_set_comparacion: 'e',
                valor: '-',
                alargamiento: null,
                c_set: null,
                carga_rot_mpa: null,
                desgarro: null,
                mindureza: null,
                maxdureza: null,
            },
        },
        listaKey: 0,
    }),
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        retrieveFormulas() {
            FormulasDataService.search(this.newSearch)
                .then((response) => {
                    // console.log("RETRIEVE FORMULAS"); console.log(response.data);
                    this.res_formulas = response.data.map(this.getPrecio);
                    this.listaKey += 1;
                    this.searching = false;
                })
                .catch((e) => {
                    console.log(e);
                    this.listaKey += 1;
                    this.searching = false;
                });
        },
        advancedSearch() {
            this.res_formulas = null;

            this.newSearch = Object.assign({}, this.model);
            this.setPostcurado();
            this.setColores();
            this.setAplicaciones();
            this.setBases();
            this.setAditivos();
            this.searching = true;
            this.retrieveFormulas();
        },
        customFilter(item, queryText, itemText) {
            const textOne = item.name.toLowerCase();
            const textTwo = item.abbr.toLowerCase();
            const searchText = queryText.toLowerCase();
            return textOne.indexOf(searchText) > -1 ||
                textTwo.indexOf(searchText) > -1;
        },
        removeColor(item) {
            for (let i = 0; i < this.model.colores.length; i++) {
                const element = this.model.colores[i];
                if (element.id_color === item.id_color) {
                    this.model.colores.splice(i, 1);
                }
            }
        },
        removeAplicacion(item) {
            for (let i = 0; i < this.model.aplicaciones.length; i++) {
                const element = this.model.aplicaciones[i];
                if (element.id_aplicacion === item.id_aplicacion) {
                    this.model.aplicaciones.splice(i, 1);
                }
            }
        },
        removeBase(item) {
            for (let i = 0; i < this.model.bases.length; i++) {
                const element = this.model.bases[i];
                if (element.cod_base === item.cod_base) {
                    this.model.bases.splice(i, 1);
                }
            }
        },
        getColorName(item) {
            let str_color = item.nombre;
            if (item.ral != "") {
                str_color += " (" + item.ral + ")";
            }
            if (item.referencia != "") {
                str_color += " [" + item.referencia + "]";
            }
            return str_color;
        },
        getBaseName(item) {
            let str_base = item.cod_base;
            if (item.descripcion != "") {
                str_base += " (" + item.descripcion + ")";
            }
            return str_base;
        },
        getAditivoName(item) {
            let str_aditivo = item.cod_aditivo;
            if (item.descripcion != "") {
                str_aditivo += " (" + item.descripcion + ")";
            }
            return str_aditivo;
        },
        setColores() {
            if (this.model.colores && !Object.keys(this.model.colores).length == 0) {
                this.newSearch.id_color = this.model.colores.map(item => item.id_color);
                delete this.newSearch.colores;
            }
        },
        setAplicaciones() {
            if (this.model.aplicaciones && !Object.keys(this.model.aplicaciones).length == 0) {
                this.newSearch.id_aplicacion = this.model.aplicaciones.map(item => item.id_aplicacion);
                delete this.newSearch.aplicaciones;
            }
        },
        setBases() {
            if (this.model.bases && !Object.keys(this.model.bases).length == 0) {
                this.newSearch.cod_base = this.model.bases.map(item => item.cod_base);
                delete this.newSearch.bases;
            }
        },
        setAditivos() {
            if (this.model.aditivos && !Object.keys(this.model.aditivos).length == 0) {
                this.newSearch.cod_aditivo = this.model.aditivos.map(item => item.cod_aditivo);
                delete this.newSearch.aditivos;
            }
        },
        setPostcurado() {
            if (this.model.postcurado.valor) this.newSearch['postcurado_valor'] = this.model.postcurado.valor;
            if (this.model.postcurado.mindureza) this.newSearch['postcurado_mindureza'] = this.model.postcurado.mindureza;
            if (this.model.postcurado.maxdureza) this.newSearch['postcurado_maxdureza'] = this.model.postcurado.maxdureza;
            if (this.model.postcurado.alargamiento_comparacion) this.newSearch['postcurado_alargamiento_comparacion'] = this.model.postcurado.alargamiento_comparacion;
            if (this.model.postcurado.alargamiento) this.newSearch['postcurado_alargamiento'] = this.model.postcurado.alargamiento;
            if (this.model.postcurado.carga_rot_mpa_comparacion) this.newSearch['postcurado_carga_rot_mpa_comparacion'] = this.model.postcurado.carga_rot_mpa_comparacion;
            if (this.model.postcurado.carga_rot_mpa) this.newSearch['postcurado_carga_rot_mpa'] = this.model.postcurado.carga_rot_mpa;
            if (this.model.postcurado.desgarro_comparacion) this.newSearch['postcurado_desgarro_comparacion'] = this.model.postcurado.desgarro_comparacion;
            if (this.model.postcurado.desgarro) this.newSearch['postcurado_desgarro'] = this.model.postcurado.desgarro;
            if (this.model.postcurado.c_set_comparacion) this.newSearch['postcurado_c_set_comparacion'] = this.model.postcurado.c_set_comparacion;
            if (this.model.postcurado.c_set) this.newSearch['postcurado_c_set'] = this.model.postcurado.c_set;

            delete this.newSearch['postcurado']

            if (this.model.sinpostcurado.valor) this.newSearch['sinpostcurado_valor'] = this.model.sinpostcurado.valor;
            if (this.model.sinpostcurado.mindureza) this.newSearch['sinpostcurado_mindureza'] = this.model.sinpostcurado.mindureza;
            if (this.model.sinpostcurado.maxdureza) this.newSearch['sinpostcurado_maxdureza'] = this.model.sinpostcurado.maxdureza;
            if (this.model.sinpostcurado.alargamiento_comparacion) this.newSearch['sinpostcurado_alargamiento_comparacion'] = this.model.sinpostcurado.alargamiento_comparacion;
            if (this.model.sinpostcurado.alargamiento) this.newSearch['sinpostcurado_alargamiento'] = this.model.sinpostcurado.alargamiento;
            if (this.model.sinpostcurado.carga_rot_mpa_comparacion) this.newSearch['sinpostcurado_carga_rot_mpa_comparacion'] = this.model.sinpostcurado.carga_rot_mpa_comparacion;
            if (this.model.sinpostcurado.carga_rot_mpa) this.newSearch['sinpostcurado_carga_rot_mpa'] = this.model.sinpostcurado.carga_rot_mpa;
            if (this.model.sinpostcurado.desgarro_comparacion) this.newSearch['sinpostcurado_desgarro_comparacion'] = this.model.sinpostcurado.desgarro_comparacion;
            if (this.model.sinpostcurado.desgarro) this.newSearch['sinpostcurado_desgarro'] = this.model.sinpostcurado.desgarro;
            if (this.model.sinpostcurado.c_set_comparacion) this.newSearch['sinpostcurado_c_set_comparacion'] = this.model.sinpostcurado.c_set_comparacion;
            if (this.model.sinpostcurado.c_set) this.newSearch['sinpostcurado_c_set'] = this.model.sinpostcurado.c_set;

            delete this.newSearch['sinpostcurado']

            this.sinpostKey += 1;
            this.conpostKey += 1;
        },
        getPrecio(item) {
            let ppc_total = 0.0
            var dict = new Object();

            for (const base of item.formula_base) {
                for (const proveedor of base.cod_base.proveedor_base) {
                    ppc_total += base.ppc;
                    dict[base.cod_base.cod_base] = {};
                    dict[base.cod_base.cod_base].ppc = base.ppc;
                    dict[base.cod_base.cod_base].precio = proveedor.precio;
                }
            }

            for (const aditivo of item.formula_aditivo) {
                for (const proveedor of aditivo.cod_aditivo.proveedor_aditivo) {
                    ppc_total += aditivo.ppc;
                    dict[aditivo.cod_aditivo.cod_aditivo] = {};
                    dict[aditivo.cod_aditivo.cod_aditivo].ppc = aditivo.ppc;
                    dict[aditivo.cod_aditivo.cod_aditivo].precio = proveedor.precio;
                }
            }

            let total = 0.0;
            for (var key in dict) {
                var value = dict[key];
                total += (value.ppc / ppc_total) * value.precio
            }
            item.precio = total.toFixed(2);
            // console.log("ITEM"); console.log(item);
            return item;
        },
    },
    mounted() {
        AplicacionesDataService.getSimple()
            .then((response) => {
                this.aplicaciones = response.data;
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false));
        ColoresDataService.getSimple()
            .then((response) => {
                this.colores = response.data;
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false));
        BasesDataService.getSimple()
            .then((response) => {
                this.bases = response.data;
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false));
        AditivosDataService.getSimple()
            .then((response) => {
                this.aditivos = response.data;
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false));
    },
    components: { Postcurado, ListaSugerencias }
};
</script>